export default {
    home: "Startseite",
    projects: "Kurse",
    community: "Gemeinschaft",
    customization: "Personalisierung",
    reports: "Berichte",
    marketing: "Marketing",
    settings: "Anpassungen",
    my_account: 'Mein Konto',
    annual_sales: "Jährliche Verkäufe",
    sales: "Vertrieb",
    students: "Studenten",
    teachers: "Lehrer",
    products: "Produkte",
    project: "Projekte",
    categories: "Kategorien",
    category: 'Kategorie',
    published: "Veröffentlicht",
    name: "Name",
    lastname: 'Nachname',
    email: "Email",
    phone: "Telefon",
    title: "Titel",
    pass: 'Passwort',
    pass_confirm: 'Bestätigung des Passworts',
    coming_soon: "Demnächst verfügbar",
    month: "Monat",
    year: "Jahr",
    date: "Datum",
    plan: 'Plan',
    pvp: "UVP",
    net: "Netz",
    total: 'Insgesamt',
    state: "Staat",
    delete: "Löschen",
    profile: "Profil",
    enrollments: "Einschreibungen",
    cancel: "Abbrechen",
    save: "Speichern Sie",
    remove: 'Löschen',
    email_address: 'Postanschrift',
    image_format: 'PNG, JPG, GIF bis zu 3 MB',
    close: 'Schließen',
    back: 'Zurück zu',
    coming_soon_brainspro: 'Demnächst bei Brainspro',
    and: 'y',
    product: "Produkt",
    date_creation: 'Datum der Erstellung',
    type: 'Typ',

    //AppComponent
    my_profile: 'Mein Profil',
    adjust: 'Anpassungen',
    out: 'Ausfahrt',
    search: 'Suche',
    academy_preview: 'Vorschau Akademie',
    my_academy: 'Meine Akademie',
    new_project: 'Neuer Kurs',
    text_current_period: 'Ihre Probezeit bis ',
    text_end_at: ' endet in ',
    plans: 'Abonnement-Pläne',
    billing: 'Rechnungen',

    //ThankYouPageComponent
    thankyou: 'Dankeschön!',
    go_to_academy: 'Go to the academy',

    //NavigationDesktop - Mobile
    records: 'Aufnahmen',
    videos: 'Videos',

    //Aviso de cambios sin guardar (FE-032)
    unsaved_changes_title: 'Du hast ungespeicherte Änderungen',
    unsaved_changes_text: 'Wenn du jetzt gehst, gehen deine ungespeicherten Änderungen verloren.',
    unsaved_changes_leave: 'Ohne Speichern verlassen',
    unsaved_changes_stay: 'Weiter bearbeiten',

    // FE-043 · RouteTabsComponent
    tabs: 'Registerkarten',

    // Botón Aula (Moodle)
    classroom_ready_title: 'Der Kursraum ist bereit',
    classroom_ready_text: 'Ihr Browser hat den neuen Tab blockiert. Klicken Sie auf „Kursraum öffnen“, um den Kurs zu betreten.',
    classroom_open: 'Kursraum öffnen',
    classroom_timeout: 'Moodle antwortet zu langsam. Bitte versuchen Sie es in ein paar Minuten erneut.',
    classroom_error: 'Der Kursraum konnte nicht geöffnet werden.',

    // Menú de navegación
    users: 'Benutzer',
    navigation_menu: 'Navigationsmenü',
    open_menu: 'Menü öffnen',
    close_menu: 'Menü schließen',
}
